<template>
<ProgressCircular v-if="loading"/>
  <form v-else novalidate ref="updatePlaceForm" :disabled="disabled" @submit.prevent="() => {}">
    <v-row no-gutters>
      <v-col cols="8">
        <v-card max-width="1200" flat color="transparent">
          <v-card-title class="mb-10">
            <FormHeader
              :loading="loading"
              :disabled="disabled"
              :link="'page-cities'"
              :title="data.title ? `${data.title} город` : `Создать город`"
            />
          </v-card-title>
          <v-tabs v-model="activeTab">
            <v-tab v-for="tab in $options.tabs" :key="tab.value">
              {{ tab.title }}
            </v-tab>
          </v-tabs>
          <v-tabs-items v-model="activeTab">
            <v-tab-item>
              <v-card-text>
                <PageContent>
                  <v-container>
                    <InputTitleSlug
                      :is-loading="loading || disabled"
                      :title="fields.title"
                      :title-error="validationErrors.title"
                      :slug="fields.slug"
                      :isSlugEnabled="!isNew"
                      :slug-error="validationErrors.slug"
                      @change:title="fields.title = $event"
                      @change:slug="fields.slug = $event"
                      @input:slug="$v.fields.slug.$touch"
                    />
                    <v-row>
                      <v-col cols="12">
                        <span>Таймзона*</span>
                        <v-autocomplete
                          no-data-text="Список пуст"
                          id="timezone"
                          outlined
                          clearable
                          :loading="loading"
                          :disabled="disabled"
                          :items="$options.timezoneList"
                          :error-messages="validationErrors.timezone"
                          v-model="fields.timezone"
                        />
                        <!--                      v-model="fields.timezone" :error-messages="validationErrors.timezone" -->
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col cols="12">
                        <span>Подзаголовок (<TranslationIcon />)</span>
                        <v-text-field
                          outlined
                          :disabled="disabled"
                          :loading="loading"
                          v-model="fields.subtitle"
                        />
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col cols="12">
                        <span>Краткое описание (<TranslationIcon />)</span>
                        <v-textarea
                          outlined
                          :disabled="disabled"
                          :loading="loading"
                          v-model="fields.shortDescription"
                        />
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col cols="12">
                        <MediaFilePicker
                          :label="'Герб'"
                          :multiple="false"
                          :file-type="$options.mediaTypesByKeys.IMAGE"
                          :value="fields.emblemId"
                          @change="fields.emblemId = $event"
                        />
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col cols="12">
                        <span>Площадь *</span>
                        <v-text-field
                          outlined
                          id="area"
                          :disabled="disabled"
                          :loading="loading"
                          :error-messages="validationErrors.area"
                          v-model="fields.area"
                        />
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col cols="12">
                        <span>Население *</span>
                        <v-text-field
                          outlined
                          id="population"
                          :disabled="disabled"
                          :loading="loading"
                          :error-messages="validationErrors.population"
                          v-model="fields.population"
                        />
                      </v-col>
                    </v-row>
                    <!--                  <v-row>-->
                    <!--                    <v-col cols="6">-->
                    <!--                      <span>Дата основания</span>-->
                    <!--                      <v-menu-->
                    <!--                        ref="menuStartDate"-->
                    <!--                        v-model="foundedAt.menu"-->
                    <!--                        :close-on-content-click="false"-->
                    <!--                        :return-value.sync="fields.foundedAt"-->
                    <!--                        min-width="auto"-->
                    <!--                      >-->
                    <!--                        <template v-slot:activator="{ on, attrs }">-->
                    <!--                          <v-row align="center" v-bind="attrs" v-on="on" no-gutters>-->
                    <!--                            <v-text-field-->
                    <!--                              hide-details-->
                    <!--                              outlined-->
                    <!--                              readonly-->
                    <!--                              :disabled="loading"-->
                    <!--                              :value="preparedFormatTime(fields.foundedAt)"-->
                    <!--                              @change="-->
                    <!--                                fields.foundedAt = prepareDateFormatPayload($event)-->
                    <!--                              "-->
                    <!--                            />-->
                    <!--                            <v-icon class="ml-2">mdi-calendar</v-icon>-->
                    <!--                          </v-row>-->
                    <!--                        </template>-->
                    <!--                        <v-date-picker-->
                    <!--                          no-title-->
                    <!--                          scrollable-->
                    <!--                          first-day-of-week="1"-->
                    <!--                          :value="fields.foundedAt"-->
                    <!--                          :active-picker.sync="foundedAt.activePicker"-->
                    <!--                          @change="fields.foundedAt = prepareDateFormatPayload($event)"-->
                    <!--                        >-->
                    <!--                          <v-spacer />-->
                    <!--                          <v-btn-->
                    <!--                            text-->
                    <!--                            color="primary"-->
                    <!--                            @click="$refs.menuStartDate.save(fields.foundedAt)"-->
                    <!--                          >-->
                    <!--                            OK-->
                    <!--                          </v-btn>-->
                    <!--                        </v-date-picker>-->
                    <!--                      </v-menu>-->
                    <!--                    </v-col>-->
                    <!--                  </v-row>-->
                    <v-row>
                      <v-col cols="6">
                        <span>Дата основания</span>
                        <div style="border: 1px solid #9e9e9e; border-radius: 4px">
                          <v-text-field
                            v-model="foundedAt"
                            style="margin-right: 10px; margin-left: 10px"
                            type="date"
                            class="native-date-input"
                            :disabled="disabled"
                            :loading="loading"
                            @click="$event => $event.preventDefault()"
                            @blur="handleFoundedAtValue"
                          />
                        </div>
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col cols="12">
                        <MediaFilePicker
                          :label="'Обложка'"
                          :multiple="false"
                          :file-type="$options.mediaTypesByKeys.IMAGE"
                          :value="fields.coverImageId"
                          @change="fields.coverImageId = $event"
                        />
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col cols="12">
                        <MediaFilePicker
                          :label="'Миниатюра'"
                          :multiple="false"
                          :file-type="$options.mediaTypesByKeys.IMAGE"
                          :value="fields.thumbnailId"
                          @change="fields.thumbnailId = $event"
                        />
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col cols="12">
                        <span>Адресс</span>
                        <LocationAutocomplete
                          v-if="!!fields.address"
                          :address="fields.address"
                          :loading="loading || disabled"
                          @set-location="fields.address = $event"
                          @update-location-part="updateLocation"
                        />
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col>
                        <SeoSettings
                          :data="data"
                          :loading="loading || disabled"
                          @on-input-seo="fields = Object.assign({}, fields, $event)"
                        />
                      </v-col>
                    </v-row>
                  </v-container>
                </PageContent>
              </v-card-text>
            </v-tab-item>
            <v-tab-item>
              <v-card-text>
                <PageContent>
                  <DynamicListWrapper
                    :list="fields.widgets"
                    :error-messages="mixValidationErrors"
                    :available-items="$options.availableWidgets"
                    :copy-clipboard="mixCopyListItemClipboard"
                    :options="$options.options"
                    @list-sort="mixListItemsReassort"
                    @add="mixCreateListItemHandler"
                    @option="mixListItemOptionHandler"
                  >
                    <template #item="{ data }">
                      <component
                        :is="data.item.type"
                        :list-item="data.item"
                        :error-messages="mixDynamicListValidationErrors[data.itemIndex]"
                        @change="mixListItemChangeHandler($event, data.itemIndex)"
                        @change-item="mixListItemChangeItemHandler($event, data.itemIndex)"
                        @remove-item="mixListItemRemoveItemHandler($event, data.itemIndex)"
                      />
                    </template>
                  </DynamicListWrapper>
                </PageContent>
              </v-card-text>
            </v-tab-item>
          </v-tabs-items>
        </v-card>
      </v-col>
      <v-col cols="4">
        <ManageSidePanel
          ref="manageSidePanel"
          :is-new="!data.id"
          isShowSortOrder
          :created-at="data.createdAt"
          :updated-at="data.updatedAt"
          :published-at="data.publishedAt"
          :author="data.author"
          :is-loading="loading"
          :is-submit-disabled="disabled"
          :entity-id="data.id"
          :entity-type="'city'"
          :language="language"
          :translations="fields.translations"
          :sortOrder="fields.sortOrder"
          @delete="$emit('delete-city')"
          @cancel="$router.push({ name: 'page-cities' })"
          @submit="submit"
          @update-translations="Object.assign(fields.translations, $event)"
          @language-update="$emit('language-update', $event)"
          @update-sort-order="fields.sortOrder = Number($event)"
        >
          <template #info-append>
            <StatusPicker
              align="center"
              cols="12"
              title="Статус:"
              :disabled="disabled"
              :loading="loading"
              :status="fields.status"
              @status:change="fields.status = $event"
            />
            <v-row v-if="!isNew" align="center">
              <v-col cols="6">
                <span>Посмотреть на сайте</span>
              </v-col>
              <v-col cols="6">
                <v-btn
                  icon
                  link
                  color="primary"
                  target="_blank"
                  :href="redirerectToWebPortal"
                  :loading="loading"
                  :disabled="disabled"
                  ><v-icon>mdi-web</v-icon></v-btn
                >
              </v-col>
            </v-row>
          </template>
          <template #body>
            <v-card flat>
              <v-card-subtitle class="grey--text"> Связи </v-card-subtitle>
              <v-card-text>
                <v-row no-gutters>
                  <v-col>
                    <span>Исторические личности</span>
                    <v-select
                      outlined
                      no-data-text="Список пуст"
                      return-object
                      item-text="name"
                      multiple
                      clearable
                      :loading="loading"
                      :disabled="disabled"
                      :value="fields.historicalFigures"
                      :items="historicalFigures"
                      v-model="fields.historicalFigures"
                    />
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
          </template>
        </ManageSidePanel>
      </v-col>
    </v-row>
  </form>
</template>
<script>
import { defaultDateFormat, apiFormat, timezoneList } from '@/configs/date.js'
import moment from 'moment'
import FormAbstract from '@/components/abstract/form'
import validationRules from './validation-rules'
import ManageSidePanel from '@/components/manage-side-panel'
import LocationAutocomplete from '@/components/location-autocomplete'
import { widgetListForCityAndPlaceList } from '@/utils/widgets'
import tabs from '@/configs/tabs.js'
import Geolocation from '@/utils/types/Geolocation.js'
import widgetParentMix from '@/mixins/widgets/widgetParent.mix.js'
import parentDynamicList from '@/mixins/dynamic-list/parentDynamicList.mix.js'
import prepareTranslations from '@/mixins/translations/prepareTranslations.mix'
import DynamicListWrapper from '@/components/dynamic-list-wrapper/DynamicListWrapper.vue'
import MediaFilePicker from '@/components/media-file-picker'
import Widget from '@/utils/widgets/Widget.js'
import SeoSettings from '@/components/seo-settings'
import TranslationIcon from '@/components/translation-icon/translationIcon'
import validationTranslations from '@/mixins/translations/validationTranslations.mix.js'
import { mediaTypesByKeys } from '@/configs/mediaFileTypes'
import FormHeader from '@/components/form-header'
import InputTitleSlug from '@/components/inputs/InputTitleSlug'
import historicalFiguresQuery from '@/services/gql/types/HistoricalFigures/queries/historicalFiguresGrid.gql'
import { mixForm } from '@/utils/form.mix.js'
import dayjs from 'dayjs'
import StatusPicker from '@/components/status-picker'
import PageContent from '@/components/page-content/PageContent.vue'
import ProgressCircular from '@/components/progress-circular'

export default {
  name: 'FormCity',
  tabs,
  defaultDateFormat,
  validationRules,
  timezoneList,
  mediaTypesByKeys: mediaTypesByKeys(),
  availableWidgets: widgetListForCityAndPlaceList,
  dynamicListName: 'widgets',
  extends: FormAbstract,
  mixins: [
    widgetParentMix,
    parentDynamicList,
    validationTranslations,
    prepareTranslations,
    mixForm
  ],
  components: {
    PageContent,
    InputTitleSlug,
    TranslationIcon,
    ManageSidePanel,
    DynamicListWrapper,
    LocationAutocomplete,
    MediaFilePicker,
    SeoSettings,
    FormHeader,
    StatusPicker,
    ProgressCircular
  },
  props: {
    data: {
      type: Object,
      default: null
    },
    language: {
      type: String,
      default: null
    },
    isNew: {
      type: Boolean,
      default: false
    },
    loading: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      activeTab: 0,
      historicalFigures: [],
      foundedAt: null,
      fields: {
        title: null,
        slug: undefined,
        subtitle: null,
        address: new Geolocation(),
        widgets: [],
        shortDescription: null,
        area: null,
        emblemId: null,
        population: null,
        foundedAt: null,
        seoMetaTitle: null,
        seoMetaDescription: null,
        seoMetaKeywords: null,
        seoDisallowIndex: false,
        seoRelCanonical: null,
        seoOgImage: null,
        status: null,
        thumbnailId: null,
        coverImageId: null,
        translations: { ru: { isEnabled: true } },
        historicalFigures: null,
        timezone: 'Europe/Moscow',
        sortOrder: null
      }
    }
  },
  computed: {
    redirerectToWebPortal () {
      if (this.data) {
        const { slug } = this.data
        return window.location.href.includes('demo')
          ? `${process.env.VUE_APP_WEB_PORTAL_URL_DEMO}/cities/${slug}`
          : `${process.env.VUE_APP_WEB_PORTAL_URL}/cities/${slug}`
      }

      return '#'
    },
    validationRulesVars () {
      return { id: this.data?.id, ctx: this, isNew: this.isNew }
    }
  },
  watch: {
    data (data) {
      this.populate(data)
      this.fields.widgets = Widget.populateList(data.widgets)
      this.fields.coverImageId = data?.coverImage?.id || null
      this.fields.emblemId = data?.emblem?.id || null
      if (data.foundedAt) {
        this.foundedAt = dayjs(data.foundedAt).format('YYYY-MM-DD')
      }
    }
  },
  methods: {
    setLocation (location) {
      this.fields.address = location
    },
    updateLocation ({ value, fieldName }) {
      this.fields.address[fieldName] = value
    },
    async submit () {
      const isValid = await this.validate()
      if (!isValid) {
        this.mixScrollToError(this.$v)
        return
      }
      this.prepereHistoricalFigures()
      const payload = {
        ...this.composeFormData(this.fields)
      }

      payload.address.lon = Number(payload.address.lon)
      payload.address.lat = Number(payload.address.lat)
      payload.area = Number(payload.area)
      payload.population = Number(payload.population)
      delete payload.seoOgImage

      this.mixPrepareTranslations(payload)
      const isWidgetsInValid = this.mixValidateDynamicList(payload.widgets)

      if (!this.mixIsValidTranslations(this.fields.translations)) {
        this.$errorMsg('Не выбран ни один язык для контента!')
        return
      }
      if (!isWidgetsInValid) {
        this.$emit('submit', {
          data: payload
        })
      } else {
        this.$errorMsg('Не заполнены обязательные поля виджетов!')
      }
    },
    prepereHistoricalFigures () {
      this.fields.historicalFigures = this.fields?.historicalFigures?.map(
        figure => figure.id
      )
    },
    preparedFormatTime (value) {
      if (value !== null) return moment(value || new Date()).format(defaultDateFormat)
      return value
    },
    prepareDateFormatPayload (value) {
      return moment(value).format(apiFormat)
    },
    handleFoundedAtValue () {
      if (this.foundedAt) {
        this.fields.foundedAt = dayjs(this.foundedAt, 'YYYY-MM-DD').format()
      } else {
        this.foundedAt = null
      }
    }
  },
  apollo: {
    historicalFigures: {
      fetchPolicy: 'network-only',
      query: historicalFiguresQuery,
      result (res) {
        if (res.data === undefined) {
          this.$handleApiError(res.error)
          this.$router.push({ name: 'page-places' })
        } else {
          this.historicalFigures = res?.data?.historicalFigures?.list || null
        }
      }
    }
  }
}
</script>

<style>
/*input[type="date"]::-webkit-inner-spin-button,*/
/*input[type="date"]::-webkit-calendar-picker-indicator {*/
/*  display: none;*/
/*  -webkit-appearance: none;*/
/*}*/
</style>
